import Cookies from "./Cookies";
export default Cookies;
